import React, { useEffect, useState } from "react";
import CloadTop from "../components/mainPage/cloadTop";
import Buttoon from "../common/Buttoon";
import { Helmet } from "react-helmet";
const MAX_MOVE = 380;
const NORMAL_MOVE = 180;
const TEMP = {
  CALENDAR: "calendar",
  TODO: "todo",
  TABLE: "table",
};
function Home({ history }) {
  const [open, setOpen] = useState(false);

  const [order, setOrder] = useState([0, 0, 0]);
  const [cloadOpacity, setCloadOpacity] = useState(1);
  const [mainTemplete, setMainTemplete] = useState("calendar");
  console.log(" width :", window.innerWidth);
  const onLeft = () => {
    switch (mainTemplete) {
      case TEMP.CALENDAR: {
        setOrder([-NORMAL_MOVE, -NORMAL_MOVE, MAX_MOVE]);
        setMainTemplete(TEMP.TABLE);
        return;
      }
      case TEMP.TABLE: {
        setOrder([-MAX_MOVE, NORMAL_MOVE, NORMAL_MOVE]);
        setMainTemplete(TEMP.TODO);
        return;
      }
      case TEMP.TODO: {
        setOrder([0, 0, 0]);
        setMainTemplete(TEMP.CALENDAR);
        return;
      }
    }
  };
  const onRight = () => {
    switch (mainTemplete) {
      case TEMP.CALENDAR: {
        setOrder([-MAX_MOVE, NORMAL_MOVE, NORMAL_MOVE]);
        setMainTemplete(TEMP.TODO);
        return;
      }
      case TEMP.TODO: {
        setOrder([-NORMAL_MOVE, -NORMAL_MOVE, MAX_MOVE]);
        setMainTemplete(TEMP.TABLE);
        return;
      }
      case TEMP.TABLE: {
        setOrder([0, 0, 0]);
        setMainTemplete(TEMP.CALENDAR);
        return;
      }
    }
    // setOrder();
  };
  const onScroll = () => {
    const home_page = document.querySelector("#home-page");
    home_page.addEventListener("scroll", (e) => {
      let point = e.target.scrollTop;
      console.log("point :", e.target.scrollTop);
      console.log("scrollButton :", e.target.scrollButton);
      if (point == 0 || point > 700) {
        setCloadOpacity(1);
      } else {
        setCloadOpacity(0.2);
      }
    });
  };
  useEffect(() => {
    onScroll();
  }, []);
  return (
    <div
      id="home-page"
      dir="rtl"
      className="relative bg-primary h-screen  w-screen  duration-700 transition-colors  overflow-x-hidden"
      // style={{ backgroundColor:'#262626' }}
    >
      <Helmet>
        <title>غيوم</title>
        <link rel="shortcut icon" href="logo.png" />
        <meta
          name="description"
          content="تطبيق غيوم هي عبارة عن منصة توفر للسمتخدمين قابلية تحميل قوالب مثل تقاويم وجدوال وغيرها"
        />
        <meta property="og:title" content="موقع غيوم" />
        <meta property="og:url" content="https://www.example.com/webpage/" />
        <meta
          property="og:description"
          content={
            "تطبيق غيوم هي عبارة عن منصة توفر للسمتخدمين قابلية تحميل قوالب مثل تقاويم وجدوال وغيرها"
          }
        ></meta>
        <meta property="og:image" content="logo.png" />
      </Helmet>
      <CloadTop cloadOpacity={cloadOpacity} />
      <div
        className="w-full bg-transparent  flex justify-around flex-col lg:flex-row "
        style={{ height: "80vh" }}
      >
        <div
          className="flex items-center flex-1 mt-24  h-full flex-col mr-10 "
          style={{ height: "40vw" }}
        >
          <img
            src={require("../assest/logo-text.png")}
            style={{ width: "170px" }}
            alt=""
            className="mb-48"
          />
          {/* <img
            style={{ height: "400px", width: "350px", marginRight: "70px" }}
            src={require("../assest/paper.png")}
            alt=""
            className="my-2"
          /> */}

          <Buttoon href={"#begin"}>ابدأ</Buttoon>
        </div>

        <div
          className="flex flex-1 h-full transform scale-75
           lg:scale-100 flex-col pt-10 lg:flex-col-reverse pr-0  pb-40 items-center  
            relative table-imag"
          style={{}}
        >
          <div
            className="flex md:absolute   "
            style={{ width: "700px", left: "130px" }}
          >
            <img
              onClick={() => setOpen(!open)}
              src={require("../assest/table.png")}
              alt=""
              className="transform  scale-75 md:scale-100 "
              style={{
                width: "670px",
                // width: "320px",
                // bottom: "900px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="w-full h-screen flex flex-col relative ">
        <div className="h-24 w-full   " style={{ height: "5vh" }} />
        <div className=" relative flex-1 flex flex-col bg-secondary ">
          <img
            src={require("../assest/split-black.png")}
            className="z-10  w-full  transition-all duration-700"
            style={{
              height: "45vh",
              // width: "130vw",
              // right: "0px",
              // left: "-20px",
            }}
            alt=""
          />
          <div className="flex-1 relative flex justify-between  items-center  ">
            <img
              className=" hidden md:block absolute  left-0 z-0 "
              src={require("../assest/block-top-left.png")}
              style={{ width: "270px", bottom: "40vh", left: "40px" }}
            />

            <div />
            <div
              id="begin"
              className=" w-2/5 relative z-30 lg:pl-24   flex justify-center lg:justify-between flex-col  items-center    mb-16 "
            >
              <div className="flex   w-full justify-center items-center   flex-col lg:flex-row">
                <div
                  onClick={onRight}
                  className=" text-white ml-5  cursor-pointer btn-color   w-6 h-6 rounded-full flex justify-center items-center"
                >
                  <span className="fa fa-angle-right text-4xl"></span>
                </div>
                <div className="flex items-center justify-around flex-1">
                  <Templete
                    onLeft={onLeft}
                    onRight={onRight}
                    disable
                    src={require("../assest/icon-table.png")}
                    width={"70%"}
                    move={order[0]}
                    isSelected={mainTemplete === TEMP.TABLE}
                    select={mainTemplete}
                  />
                  <Templete
                    onLeft={onLeft}
                    onRight={onRight}
                    onClick={() => history.push("/template")}
                    width={"45%"}
                    src={require("../assest/icon-calender.png")}
                    move={order[1]}
                    isSelected={mainTemplete === TEMP.CALENDAR}
                    select={mainTemplete}
                  />
                  <Templete
                    disable
                    onLeft={onLeft}
                    onRight={onRight}
                    src={require("../assest/icon-todo.png")}
                    move={order[2]}
                    isSelected={mainTemplete === TEMP.TODO}
                    width={"40%"}
                    select={mainTemplete}
                  />
                </div>

                <div
                  onClick={onLeft}
                  className=" text-white  mr-5 cursor-pointer btn-color   w-6 h-6 rounded-full flex justify-center items-center"
                >
                  <span className="fa fa-angle-left text-4xl"></span>
                </div>
              </div>
            </div>
            <div></div>
            <img
              className="absolute bottom-0  left-0 z-20 
              transform scale-25  ANIMATION_DORG"
              src={require("../assest/block-left-bottom.png")}
              style={{
                width: window.innerWidth > 640 ? "220px" : "140px",
                left: window.innerWidth > 640 ? "70px" : "0px",
                bottom: "40px",
              }}
            />
            <img
              className="hidden md:block absolute right-0 z-20 top-0  "
              src={require("../assest/block-right.png")}
              style={{ width: "180px", top: "-10px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
const Templete = ({
  src,
  width = "50%",
  onClick,
  disable = false,
  move,
  isSelected,
  onRight,
  onLeft,
}) => (
  <div
    className={
      "flex items-center  justify-center transition-transform duration-200 "
    }
    style={{
      transform: `scale(${
        window.innerWidth > 640 ? (isSelected ? 1.15 : 1) : "0.7"
      }) translateX(${move}px) `,
      borderRadius: "2px",
      // marginRight: window.innerWidth > 640 ? "70px" : "0px",
    }}
  >
    <div
      onClick={onClick}
      style={{
        width: "150px",
        transform: ``,
      }}
      className={`h-56 box-template-select  
      flex flex-col justify-center items-center
      
    cursor-pointer  shadow-md  text-white  `}
    >
      <img
        src={src}
        alt=""
        style={{ width: width, opacity: disable ? 0.2 : 1 }}
      />
    </div>
  </div>
);
export default Home;
